import { jsxs as V, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as H } from "./index.es2359.js";
function e({ size: l = H }) {
  return /* @__PURE__ */ V(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C("path", { d: "M14 19.5C14 17.567 15.567 16 17.5 16H28V25H14V19.5Z", fill: "#E1E2FF" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M14 35C14 33.3431 15.3431 32 17 32H25C26.6569 32 28 33.3431 28 35V40H14V35Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29 39C29 37.3431 30.3431 36 32 36H40C41.6569 36 43 37.3431 43 39V40H29V39Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29 23.5C29 21.567 30.567 20 32.5 20H43V29H29V23.5Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M19.5 30.5H22.5V32C22.5 32.8284 21.8284 33.5 21 33.5C20.1716 33.5 19.5 32.8284 19.5 32V30.5Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C("path", { d: "M16 27C14.8954 27 14 26.1046 14 25V23H17V27H16Z", fill: "white" }),
        /* @__PURE__ */ C("path", { d: "M26 27C27.1046 27 28 26.1046 28 25V23H25V27H26Z", fill: "white" }),
        /* @__PURE__ */ C("path", { d: "M16 27C14.8954 27 14 26.1046 14 25V23H17V27H16Z", fill: "white" }),
        /* @__PURE__ */ C("path", { d: "M26 27C27.1046 27 28 26.1046 28 25V23H25V27H26Z", fill: "white" }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 20.1139C16 20.051 16.051 20 16.1139 20H25.8861C25.949 20 26 20.051 26 20.1139V26.5C26 29.2614 23.7614 31.5 21 31.5L-nan -nanL21 31.5C18.2386 31.5 16 29.2614 16 26.5V20.1139Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M34.5 34.5H37.5V36C37.5 36.8284 36.8284 37.5 36 37.5C35.1716 37.5 34.5 36.8284 34.5 36V34.5Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C("path", { d: "M31 31C29.8954 31 29 30.1046 29 29V27H32V31H31Z", fill: "white" }),
        /* @__PURE__ */ C("path", { d: "M41 31C42.1046 31 43 30.1046 43 29V27H40V31H41Z", fill: "white" }),
        /* @__PURE__ */ C("path", { d: "M31 31C29.8954 31 29 30.1046 29 29V27H32V31H31Z", fill: "white" }),
        /* @__PURE__ */ C("path", { d: "M41 31C42.1046 31 43 30.1046 43 29V27H40V31H41Z", fill: "white" }),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M31 24.1139C31 24.051 31.051 24 31.1139 24H40.8861C40.949 24 41 24.051 41 24.1139V30.5C41 33.2614 38.7614 35.5 36 35.5L-nan -nanL36 35.5C33.2386 35.5 31 33.2614 31 30.5V24.1139Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M34.715 30.9164C34.6136 30.6596 34.3232 30.5335 34.0663 30.6349C33.8095 30.7363 33.6834 31.0267 33.7848 31.2836C34.1289 32.1554 34.9933 32.7667 35.9994 32.7667C37.0056 32.7667 37.8695 32.1553 38.2147 31.2842C38.3165 31.0275 38.1908 30.7369 37.9341 30.6352C37.6774 30.5334 37.3868 30.6591 37.2851 30.9158C37.0907 31.4063 36.5949 31.7667 35.9994 31.7667C35.4037 31.7667 34.9083 31.4062 34.715 30.9164Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M29 23.5C29 21.567 30.567 20 32.5 20H43V29C43 30.1046 42.1046 31 41 31H40.9753C40.7933 32.8337 39.6206 34.3759 38 35.084V36H40C41.6569 36 43 37.3431 43 39V40H29V39C29 37.3431 30.3431 36 32 36H34V35.084C32.3794 34.3759 31.2067 32.8337 31.0247 31H31C29.8954 31 29 30.1046 29 29V23.5ZM32.5 21H42V27H41V24.1139C41 24.051 40.949 24 40.8861 24H31.1139C31.051 24 31 24.051 31 24.1139V27H30V23.5C30 22.1193 31.1193 21 32.5 21ZM30 28V29C30 29.5523 30.4477 30 31 30V28H30ZM32 25V30.5C32 32.7091 33.7909 34.5 36 34.5C38.2091 34.5 40 32.7091 40 30.5V25H32ZM41 30C41.5523 30 42 29.5523 42 29V28H41V30ZM36 35.5C36.3425 35.5 36.6769 35.4656 37 35.4V36C37 36.5523 36.5523 37 36 37C35.4477 37 35 36.5523 35 36V35.4C35.3231 35.4656 35.6575 35.5 36 35.5ZM37.7324 37C37.3866 37.5978 36.7403 38 36 38C35.2597 38 34.6134 37.5978 34.2676 37H32C30.8954 37 30 37.8954 30 39H42C42 37.8954 41.1046 37 40 37H37.7324Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M19.715 26.9164C19.6136 26.6596 19.3232 26.5335 19.0663 26.6349C18.8095 26.7363 18.6834 27.0267 18.7848 27.2836C19.1289 28.1554 19.9933 28.7667 20.9994 28.7667C22.0056 28.7667 22.8695 28.1553 23.2147 27.2842C23.3165 27.0275 23.1908 26.7369 22.9341 26.6352C22.6774 26.5334 22.3868 26.6591 22.2851 26.9158C22.0907 27.4063 21.5949 27.7667 20.9994 27.7667C20.4037 27.7667 19.9083 27.4062 19.715 26.9164Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M28 25V16H17.5C15.567 16 14 17.567 14 19.5V25C14 26.1046 14.8954 27 16 27H16.0247C16.2067 28.8337 17.3794 30.3759 19 31.084V32H17C15.3431 32 14 33.3431 14 35V40H28V35C28 33.3431 26.6569 32 25 32H23V31.084C24.6206 30.3759 25.7933 28.8337 25.9753 27H26C27.1046 27 28 26.1046 28 25ZM22 31.4C21.6769 31.4656 21.3425 31.5 21 31.5C20.6575 31.5 20.3231 31.4656 20 31.4V32C20 32.5523 20.4477 33 21 33C21.5523 33 22 32.5523 22 32V31.4ZM22.7324 33C22.3866 33.5978 21.7403 34 21 34C20.3096 34 19.701 33.6502 19.3416 33.1182C19.3156 33.0797 19.2909 33.0403 19.2676 33H17C15.8954 33 15 33.8954 15 35V39H27V35C27 33.8954 26.1046 33 25 33H22.7324ZM17.5 17H27V23H26V20.1139C26 20.051 25.949 20 25.8861 20H16.1139C16.051 20 16 20.051 16 20.1139V23H15V19.5C15 18.1193 16.1193 17 17.5 17ZM17 21H25V26.5C25 28.7091 23.2091 30.5 21 30.5C18.7909 30.5 17 28.7091 17 26.5V21ZM16 24H15V25C15 25.5523 15.4477 26 16 26V24ZM26 26C26.5523 26 27 25.5523 27 25V24H26V26Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
e.__tags = [];
export {
  e as MetricDemographicsIcon
};
//# sourceMappingURL=index.es388.js.map
